module.exports = __webpack_public_path__ + "static/img/bg-en.ef1d56d7.png";